import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-20 bg-pink-light/30" data-id="element-182">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm text-center relative" data-id="element-184">
          <Quote className="absolute top-8 left-8 text-pink-light opacity-50" size={64} data-id="element-185" />

          <div className="flex justify-center gap-1 mb-6 relative z-10" data-id="element-186">
            {[...Array(5)].map((_, i) => <Star key={i} className="text-yellow-400 fill-yellow-400" size={24} data-id="element-187" />)}
          </div>

          <h3 className="text-2xl md:text-3xl font-bold text-slate mb-6 relative z-10 leading-relaxed" data-id="element-188">
            "Este no es un libro de teoría. Es un sistema de acción."
          </h3>

          <p className="text-lg md:text-xl text-slate-light mb-8 relative z-10" data-id="element-189">
            Imagina que en solo 72 horas, la mayor preocupación de tus mañanas
            desaparezca por completo.
          </p>

          <div className="inline-block bg-cream-dark px-6 py-3 rounded-full relative z-10" data-id="element-190">
            <p className="font-medium text-slate" data-id="element-191">
              <span className="font-bold text-teal" data-id="element-192">Miles de madres</span> ya
              han pasado de la frustración a la libertad usando este mismo
              calendario de 3 días.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}